// Generated from the design template (Aithora ConsoleV3.dc.html T17311-17316) by the
// port's converter: every element, inline style string, whitespace run and {{ value }}
// span is the design's own. Values come from the page's vals (see the matching *Vals).
/* eslint-disable @typescript-eslint/no-explicit-any */
import { sx } from '../../ui/designStyles';
import { hov } from './dom';

export function FpPageHeadView({ V }: { V: Record<string, any> }) {
  return (
    <>
{' '}
{V.fpNotHome && (<>{' '}<div style={sx("flex:0 0 auto;display:flex;align-items:center;gap:8px 16px;flex-wrap:wrap;margin-top:10px;padding-bottom:10px;border-bottom:1px solid rgba(34,39,46,.13);")}>{' '}<a href="#" onClick={V.fpGoHome} style={sx("display:inline-flex;align-items:center;gap:8px;height:40px;padding:0 14px 0 10px;border-radius:9px;border:1px solid rgba(34,39,46,.18);color:#22272E;font-size:16px;font-weight:700;text-decoration:none;white-space:nowrap;")} {...hov("border-color:rgba(47,92,151,.5);color:#264C7E;")}>{"← "}<span>{V.fpBackLabel}</span></a>{' '}<span style={sx("font-size:19px;font-weight:800;letter-spacing:-.015em;")}><span>{V.fpPageTitle}</span></span>{' '}</div>{' '}</>)}
    </>
  );
}
